import * as React from 'react';
import { Layouts, NewbuildingLayoutsContext, ILayoutRoomCount } from '@cian/frontend-newbuilding-layouts-widget';
import { useApplicationContext } from '../../utils/applicationContext';
import { useSelector } from 'react-redux';
import {
  newbuildingIdSelector,
  buildingHasLayoutsSelector,
  houseByIdSelector,
  roomsCountListSelector,
} from '../../selectors/newbuilding';
import { HousesFilterContainer } from '../HousesFilterDesktop';
import { BuilderOffersNotAvailable } from '../BuilderOffersNotAvailable';

/* istanbul ignore next */
export const LayoutsWidgetDesktop = (): React.JSX.Element => {
  const { httpApi, logger } = useApplicationContext();

  const [houseId, setHouseId] = React.useState<number | undefined>();

  const newbuildingId = useSelector(newbuildingIdSelector);
  const hasLayouts = useSelector(buildingHasLayoutsSelector);
  const roomsCountList: ILayoutRoomCount[] = useSelector(roomsCountListSelector(houseId));
  const house = useSelector(houseByIdSelector(houseId));

  const isHouseLayoutsAvailable = houseId ? Boolean(house?.hasLayouts) : hasLayouts;

  const onHouseFilterReset = () => {
    setHouseId(undefined);
  };

  const contextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  if (!hasLayouts) {
    return <BuilderOffersNotAvailable />;
  }

  return (
    <div data-testid="offers-layouts">
      <HousesFilterContainer selectedHouseId={houseId} onClick={setHouseId} />
      <NewbuildingLayoutsContext.Provider value={contextValue}>
        <Layouts
          newbuildingId={newbuildingId}
          houseId={houseId}
          pageTypeJK="Seo"
          isHouseLayoutsAvailable={isHouseLayoutsAvailable}
          roomsCountList={roomsCountList}
          onHouseFilterReset={onHouseFilterReset}
          contactsButton={<div />}
          isQueryParamsEnabled={true}
        />
      </NewbuildingLayoutsContext.Provider>
    </div>
  );
};
